import { render } from "./BranchComparison.vue?vue&type=template&id=658c1a83&scoped=true"
import script from "./BranchComparison.vue?vue&type=script&lang=js"
export * from "./BranchComparison.vue?vue&type=script&lang=js"

import "./BranchComparison.vue?vue&type=style&index=0&id=658c1a83&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658c1a83"]])

export default __exports__